import React, {useEffect, useRef, useState} from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { clsx } from "clsx";
import ContentArea from "../ContentArea";
import ButtonBlock from "../ButtonBlock";
import MediaArea from "../MediaArea";
import PropositionBlocks from "../PropositionBlocks";

const TwoColumnLayout = ({ settings, blocks, props }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const { globals } = props;

  const layout = isMobile ? settings.layout_type_mobile : settings.layout_type;
  const imageWidth = isMobile ? settings.width_mobile : settings.width;
  const description = settings.content || '';
  const content_gap = isMobile ? settings.content_gap_mobile : settings.content_gap_desktop;
  const gap_with_media = isMobile ? settings.gap_with_media_mobile : settings.gap_with_media_desktop;
  const content_alignment =  isMobile ? settings.content_alignment_mobile: settings.content_alignment_desktop;
  const showPropositions = settings.show_propositions || false;
 
  const reverselayout = settings.reverse_layout || '';
  const classes = settings.classes || '';

  return (
    <section className={`w-full ${classes} twi-${layout}`}>
      <div
        className={`twi-${layout}__container lg:h-[${settings.container_height}px] overflow-hidden relative`}
      >
          <div
            className={`twi-${layout}__content ${clsx({
              "flex-col": isMobile,
              "flex-col-reverse": isMobile && settings.reverse_layout_mobile,
              "flex-row-reverse": reverselayout && settings.reverse_layout,
            })}`}
            style={{ gap: `${gap_with_media}px` }}
          >
          <div
            className="twi-container"
            style={{
              flexBasis: `calc(${100 - parseFloat(imageWidth)}%)`,
            }}
          >
            <div
              className={`twi-${layout}__content gap-x-[20px]
          ${
            settings.padding_area == "inside" &&
            ` pt-[${settings.padding_top_mobile}px]` +
              ` lg:pt-[${settings.padding_top_desktop}px]` +
              ` pb-[${settings.padding_bottom_mobile}px]` +
              ` lg:pb-[${settings.padding_bottom_desktop}px]` +
              ` px-[${settings.padding_left_right_mobile}px]` +
              ` lg:px-[${settings.padding_left_right_desktop}px]`
          }
          ${clsx({
            "flex-col": isMobile,
            "flex-col-reverse": isMobile && settings.reverse_layout_mobile,
            "flex-row-reverse": reverselayout && settings.reverse_layout,
          })}`}
            >
              <div
                className={`twi-${layout}__data justify-${settings.content_position_desktop} items-${content_alignment} text-${content_alignment} gap-[${content_gap}px]`}
              >

                <ContentArea settings={settings} description={description} isMobile={isMobile} />
                <ButtonBlock blocks={blocks} settings={settings} />
              </div>
            </div>
          </div>

          <div
            className="flex flex-col justify-center space-y-4 lg:basis-1/2"
            style={{ flexBasis: imageWidth + "%" }}
          >
            <div className={`flex h-full w-full`}>
              <MediaArea globals={globals} settings={settings} isMobile={isMobile} />
            </div>
          </div>

 
        </div>
       { showPropositions && <PropositionBlocks settings={settings} isMobile={isMobile}> </PropositionBlocks> }
      </div>
    </section>
  );
};

export default TwoColumnLayout;
